import React from "react";
import { string } from "prop-types";

const DesktopProfileIcon = ({
  height = "50.512",
  width = "50.513",
  minX = "0",
  minY = "0",
  x = "55.513",
  y = "55.512",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsxink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={`${minX} ${minY} ${x} ${y}`}
    >
      <defs>
        <filter id="Path_133482" x="0" y="0" width="60.513" height="60.512" filterUnits="userSpaceOnUse">
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>

      <g id="Group_31434" data-name="Group 31434" transform="translate(-306.511 -6.511)">
        <g id="Group_31331" data-name="Group 31331" transform="translate(309 11)">
          <path
            id="Path_133484"
            data-name="Path 133484"
            d="M25.007,0A25.007,25.007,0,1,1,0,25.007,25.007,25.007,0,0,1,25.007,0Z"
            fill="#f5f5f5"
          />
        </g>
        <g id="Group_31431" data-name="Group 31431" transform="translate(312.751 14.751)">
          <g transform="matrix(1, 0, 0, 1, -9, -9)" filter="url(#Path_133482)">
            <g id="Path_133482-2" data-name="Path 133482" transform="translate(9 9)" fill="#bababa">
              <path
                d="M 21.25616073608398 42.01232147216797 C 18.45388031005859 42.01232147216797 15.73568058013916 41.46360015869141 13.17708110809326 40.38140106201172 C 10.70551109313965 39.33602142333984 8.485711097717285 37.83935165405273 6.579340934753418 35.93297958374023 C 4.672970771789551 34.026611328125 3.176300764083862 31.80681037902832 2.130920648574829 29.33524131774902 C 1.048720717430115 26.77663993835449 0.5000007152557373 24.05844116210938 0.5000007152557373 21.25616073608398 C 0.5000007152557373 18.45388031005859 1.048720717430115 15.73568058013916 2.130920648574829 13.17708110809326 C 3.176300764083862 10.70551109313965 4.672970771789551 8.485711097717285 6.579340934753418 6.579340934753418 C 8.485711097717285 4.672970771789551 10.70551109313965 3.176300764083862 13.17708110809326 2.130920648574829 C 15.73568058013916 1.048720717430115 18.45388031005859 0.5000007152557373 21.25616073608398 0.5000007152557373 C 24.05844116210938 0.5000007152557373 26.77663993835449 1.048720717430115 29.33524131774902 2.130920648574829 C 31.80681037902832 3.176300764083862 34.026611328125 4.672970771789551 35.93297958374023 6.579340934753418 C 37.83935165405273 8.485711097717285 39.33602142333984 10.70551109313965 40.38140106201172 13.17708110809326 C 41.46360015869141 15.73568058013916 42.01232147216797 18.45388031005859 42.01232147216797 21.25616073608398 C 42.01232147216797 24.05844116210938 41.46360015869141 26.77663993835449 40.38140106201172 29.33524131774902 C 39.33602142333984 31.80681037902832 37.83935165405273 34.026611328125 35.93297958374023 35.93297958374023 C 34.026611328125 37.83935165405273 31.80681037902832 39.33602142333984 29.33524131774902 40.38140106201172 C 26.77663993835449 41.46360015869141 24.05844116210938 42.01232147216797 21.25616073608398 42.01232147216797 Z"
                stroke="none"
              />
              <path
                d="M 21.25616073608398 1 C 18.52116012573242 1 15.86849021911621 1.535430908203125 13.37186050415039 2.591419219970703 C 10.95989036560059 3.611598968505859 8.793510437011719 5.072280883789062 6.932891845703125 6.932891845703125 C 5.072280883789062 8.793510437011719 3.611598968505859 10.95989036560059 2.591419219970703 13.37186050415039 C 1.535430908203125 15.86849021911621 1 18.52116012573242 1 21.25616073608398 C 1 23.99116134643555 1.535430908203125 26.64382934570312 2.591419219970703 29.14046096801758 C 3.611598968505859 31.55243110656738 5.072280883789062 33.71881103515625 6.932891845703125 35.57942962646484 C 8.793510437011719 37.44004058837891 10.95989036560059 38.90072250366211 13.37186050415039 39.92090225219727 C 15.86849021911621 40.97689056396484 18.52116012573242 41.51232147216797 21.25616073608398 41.51232147216797 C 23.99116134643555 41.51232147216797 26.64382934570312 40.97689056396484 29.14046096801758 39.92090225219727 C 31.55243110656738 38.90072250366211 33.71881103515625 37.44004058837891 35.57942962646484 35.57942962646484 C 37.44004058837891 33.71881103515625 38.90072250366211 31.55243110656738 39.92090225219727 29.14046096801758 C 40.97689056396484 26.64382934570312 41.51232147216797 23.99116134643555 41.51232147216797 21.25616073608398 C 41.51232147216797 18.52116012573242 40.97689056396484 15.86849021911621 39.92090225219727 13.37186050415039 C 38.90072250366211 10.95989036560059 37.44004058837891 8.793510437011719 35.57942962646484 6.932891845703125 C 33.71881103515625 5.072280883789062 31.55243110656738 3.611598968505859 29.14046096801758 2.591419219970703 C 26.64382934570312 1.535430908203125 23.99116134643555 1 21.25616073608398 1 M 21.25616073608398 0 C 32.99561309814453 0 42.51232147216797 9.516712188720703 42.51232147216797 21.25616073608398 C 42.51232147216797 32.99561309814453 32.99561309814453 42.51232147216797 21.25616073608398 42.51232147216797 C 9.516712188720703 42.51232147216797 0 32.99561309814453 0 21.25616073608398 C 0 9.516712188720703 9.516712188720703 0 21.25616073608398 0 Z"
                stroke="none"
                fill="#bababa"
              />
            </g>
          </g>
          <path
            id="Intersection_1"
            data-name="Intersection 1"
            d="M17.306,16.728A21.238,21.238,0,0,1,0,7.315C.8,4.374,2.155,1.711,4.411.772c5.953-2.46,8.11,1.786,13.37,1.82h.063c5.3,0,7.451-4.3,13.43-1.825,2.167.9,3.49,3.363,4.3,6.145A21.24,21.24,0,0,1,18,16.728Z"
            transform="translate(3.6 25.783)"
            fill="#fff"
          />
          <path
            id="Path_133481"
            data-name="Path 133481"
            d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z"
            transform="translate(13.754 8.753)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

DesktopProfileIcon.propTypes = {
  height: string,
  width: string,
  minX: string,
  minY: string,
  x: string,
  y: string,
};

export default DesktopProfileIcon;
